import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { PureComponent } from 'react';
import { FORM_FIELD_DATE_RANGE_SEPARATOR } from '../../../../constants/FormConstants';
import { convertToDayJsDate } from '../../../../util/DateUtil';
export var FormFieldDateViews;
(function (FormFieldDateViews) {
    FormFieldDateViews["YEARS"] = "years";
    FormFieldDateViews["MONTHS"] = "months";
    FormFieldDateViews["DAYS"] = "days";
})(FormFieldDateViews || (FormFieldDateViews = {}));
class DateField extends PureComponent {
    constructor(props) {
        super(props);
        this.handleChange = e => {
            const { field } = this.props;
            field.onChange(e);
        };
        this.initDatepicker = () => {
            this.datepicker = $(this.datepickerRef.current)
                .datepicker(Object.assign({ inline: false, view: FormFieldDateViews.YEARS, firstDay: 1, dateFormat: 'dd-mm-yyyy', startDate: new Date(1980, 0, 1), language: 'en', onShow: this.onShowDatepicker, onSelect: this.onSelectDatepicker, classes: 'm-datepicker', range: false, multipleDatesSeparator: FORM_FIELD_DATE_RANGE_SEPARATOR }, this.props.data))
                .data('datepicker');
        };
        this.onShowDatepicker = () => {
            const { field } = this.props;
            const inputValue = field.value;
            if (inputValue && inputValue !== '') {
                const date = this.formatToMomentDate(inputValue);
                this.datepicker.selectDate(date);
                this.datepicker.view = FormFieldDateViews.DAYS;
            }
            else {
                this.datepicker.view = FormFieldDateViews.YEARS;
            }
        };
        this.onSelectDatepicker = (formattedDate) => {
            const { field } = this.props;
            const eventData = {
                target: {
                    name: field.name,
                    value: formattedDate,
                },
            };
            this.handleChange(eventData);
        };
        this.formatToMomentDate = (inputValue) => {
            const momentDate = convertToDayJsDate(inputValue);
            if (!!momentDate && momentDate.isValid()) {
                return momentDate.toDate();
            }
            return '';
        };
        this.datepickerRef = React.createRef();
    }
    componentDidMount() {
        this.initDatepicker();
    }
    render() {
        const { field, className, data } = this.props;
        let type = 'text';
        if (data && data.inline) {
            type = 'hidden';
        }
        return (_jsx("input", { type: type, ref: this.datepickerRef, className: className, name: field.name, placeholder: field.placeholder, value: field.value, onBlur: field.onBlur, onChange: this.handleChange }));
    }
}
export default DateField;
